export default __webpack_public_path__ + "static/media/leadership.e39b64d9.svg";